
import React, { useState } from 'react';
import './OrganizerRegistration.css';
import ApiService from '../api_services/apiService.jsx';
import GusService from '../api_services/gusService.js';

function OrganizerRegistration({ onBack, onRegistrationComplete }) {
    const [step, setStep] = useState(1);
    const [isLoadingGUS, setIsLoadingGUS] = useState(false);
    const [formData, setFormData] = useState({
        nip: '',
        companyName: '',
        street: '',
        postalCode: '',
        city: '',
        contactEmail: '',
        description: '',
        socialLink: '',
        siteLink: '',
        contactPhoneNo: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Sprawdzenie czy NIP ma dokładnie 10 cyfr
    const isNipValid = formData.nip.replace(/[^0-9]/g, '').length === 10;

    const connectWithGUS = async () => {
        const cleanNip = formData.nip.replace(/[^0-9]/g, '');

        if (cleanNip.length !== 10) {
            alert('Podaj poprawny 10-cyfrowy numer NIP');
            return;
        }

        setIsLoadingGUS(true);

        try {
            console.log('🚀 Pobieranie danych z GUS API...');
            const companyData = await GusService.fetchFirmaByNip(cleanNip);

            // Mapowanie danych z API do formularza
            setFormData(prev => ({
                ...prev,
                companyName: companyData.nazwa || prev.companyName,
                street: companyData.adres || prev.street,
                postalCode: companyData.kodPocztowy || prev.postalCode,
                city: companyData.miasto || prev.city,
            }));

            // alert('✅ Dane zostały pobrane z GUS!');
        } catch (error) {
            console.error('❌ Błąd:', error);
            alert(error.message || 'Nie udało się pobrać danych. Sprawdź numer NIP i spróbuj ponownie.');
        } finally {
            setIsLoadingGUS(false);
        }
    };

    const handleNext = async (e) => {
        e.preventDefault();

        if (step === 1) {
            if (!formData.companyName || !formData.contactEmail) {
                alert('Wypełnij wymagane pola');
                return;
            }
            setStep(2);
        } else {
            if (!formData.description) {
                alert('Opisz swoją działalność');
                return;
            }

            try {
                const { contactPhoneNo, ...profileData } = formData;
                const response = await ApiService.post('/api/organiser/profiles/registration', {
                    ...profileData,
                    contactPhone: contactPhoneNo,
                }, {
                    headers: ApiService.getHeadersJsonUTF8OrDifferent()
                });
                console.log('Rejestracja zakończona:', response);

                if (onRegistrationComplete) {
                    onRegistrationComplete();
                }
            } catch (error) {
                console.error('Błąd rejestracji:', error);
                alert('Nie udało się zarejestrować. Spróbuj ponownie.');
            }
        }
    };

    return (
        <div className="registration-page">
            <div className="registration-scroll-container">
                <div className="registration-container">
                    <div className="registration-header">
                        <h1 className="registration-logo">
                            <span className="logo-text">Witaj!</span>
                        </h1>
                        <span className="step-indicator">{step}/2</span>
                    </div>

                    <p className="registration-subtitle">
                        Uzupełnij dane, aby zarejestrować się jako organizator
                    </p>

                    <form className="registration-form" onSubmit={handleNext}>
                        {step === 1 && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="nip">NIP (Jeśli dotyczy)</label>
                                    <div className="input-with-button">
                                        <input
                                            type="text"
                                            id="nip"
                                            name="nip"
                                            placeholder="0000000000"
                                            value={formData.nip}
                                            onChange={handleInputChange}
                                            maxLength="10"
                                        />
                                        <button
                                            type="button"
                                            className="ceidg-button"
                                            onClick={connectWithGUS}
                                            disabled={isLoadingGUS || !isNipValid}
                                        >
                                            {isLoadingGUS ? 'Pobieranie...' : 'Pobierz dane z GUS'}
                                        </button>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="companyName">Nazwa organizatora *</label>
                                    <input
                                        type="text"
                                        id="companyName"
                                        name="companyName"
                                        placeholder="Nazwa"
                                        value={formData.companyName}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="street">Ulica</label>
                                    <input
                                        type="text"
                                        id="street"
                                        name="street"
                                        value={formData.street}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="form-row">
                                    <div className="form-group half">
                                        <label htmlFor="postalCode">Kod pocztowy</label>
                                        <input
                                            type="text"
                                            id="postalCode"
                                            name="postalCode"
                                            placeholder="00-000"
                                            value={formData.postalCode}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group half">
                                        <label htmlFor="city">Miasto</label>
                                        <input
                                            type="text"
                                            id="city"
                                            name="city"
                                            placeholder="Nazwa miasta"
                                            value={formData.city}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="contactEmail">Kontakt *</label>
                                    <input
                                        type="email"
                                        id="contactEmail"
                                        name="contactEmail"
                                        placeholder="adres e-mail"
                                        value={formData.contactEmail}
                                        onChange={handleInputChange}
                                    />
                                    <input
                                        type="phone"
                                        id="contactPhoneNo"
                                        name="contactPhoneNo"
                                        placeholder="numer telefonu"
                                        value={formData.contactPhoneNo}
                                        onChange={handleInputChange}
                                    />
                                    <a className="email-contact">Numer telefonu wykorzystujemy wyłącznie do
                                        kontaktu w sprawach technicznych, organizacyjnych lub związanych z weryfikacją
                                        konta. Nie służy do celów marketingowych.</a>
                                </div>
                            </>
                        )}

                        {step === 2 && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="description">Opisz swoją działalność *</label>
                                    <textarea
                                        id="description"
                                        name="description"
                                        placeholder="Wystarczy kilka zdań - pomoże nam to zweryfikować organizatora."
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        rows="4"
                                        className="textarea-field"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="socialLink">Link do profilu (np. Facebook, Instagram)</label>
                                    <input
                                        type="url"
                                        id="socialLink"
                                        name="socialLink"
                                        placeholder="https://"
                                        value={formData.socialLink}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="siteLink">Strona www</label>
                                    <input
                                        type="url"
                                        id="siteLink"
                                        name="siteLink"
                                        placeholder="https://"
                                        value={formData.siteLink}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </>
                        )}

                        <div className="flex-line">
                            {step === 2 && (
                                <button
                                    type="button"
                                    className="registration-white-button"
                                    onClick={() => setStep(1)}
                                >
                                    ← Wstecz
                                </button>
                            )}
                            <button type="submit" className="registration-submit-button">
                                {step === 1 ? 'Dalej' : 'Załóż konto organizatora'}
                            </button>
                        </div>
                    </form>

                    {step === 1 && onBack && (
                        <button
                            type="button"
                            className="back-to-login"
                            onClick={onBack}
                        >
                            Powrót do logowania
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default OrganizerRegistration;
